module.exports = __webpack_public_path__ + "static/media/termopary11kz.f11b930b.pdf";